import React, { useEffect, useRef, useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FloatLabel from "../../../UiComponents/FloatLabel/FloatLabel";
import { Formik, Form, Field } from "formik";
import {
  PostBranch,
  UpdateBranch,
  UpdatePolicyList,
  LoginPortalData,
} from "../../../Service/_index";
import CloseIcon from "@mui/icons-material/Close";
import { ToastError, ToastSuccess } from "../../../UiComponents/Toaster/Toast";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Styles from "../../../UiComponents/Scss/AddPopup.module.scss";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import CircularProgress from "@mui/material/CircularProgress";

const UpdateLoginStatus = (props) => {
  const {
    selectedData,
    formType,
    setOpenDrawer,
    title,
    GetActiveData,
    handleOnClickBehaviour,
  } = props;
  // console.log("SelectedData: ", selectedData);
  let formRef = useRef();
  const [selectedUserId, setSelectedUserId] = useState(
    selectedData?.userId?._id
  );
  const [selectedCompanyId, setSelectedCompanyId] = useState(
    selectedData?.companyId?._id
  );
  const [selectedLoginPortal, setSelectedLoginPortal] = useState(null);
  // The user's own portal logins of this company, plus the shared "All" / "Admin" ones (the list the Edit Policy page offers)
  const [loginPortalDetails, setLoginPortalDetails] = useState([]);
  const [loginPortalLoading, setLoginPortalLoading] = useState(false);
  useEffect(() => {
    if (!selectedUserId || !selectedCompanyId) {
      setLoginPortalDetails([]);
      return undefined;
    }
    let cancelled = false;
    setLoginPortalLoading(true);
    LoginPortalData({
      userId: selectedUserId,
      companyId: selectedCompanyId,
      isActive: true,
    })
      .then((res) => {
        if (cancelled) return;
        const rows = (res?.data || []).filter(
          (item) =>
            item?.companyId === selectedCompanyId &&
            [selectedUserId, "All", "Admin"].includes(item?.userId),
        );
        setLoginPortalDetails(rows);
      })
      .finally(() => {
        if (!cancelled) setLoginPortalLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [selectedUserId, selectedCompanyId]);
  const [refreshField, setRefreshField] = useState(0);
  const [refreshFieldSubCode, setRefreshFieldSubCode] = useState(1);
  const [isEyeLoading, setIsEyeLoading] = useState(false);

  const initialValues = {
    loginId: {
      companyId: selectedCompanyId,
      userId: selectedUserId,
    },
    loginIdFull: "",
  };
  // console.log("bookingCode:", selectedData?.bookingCodeId?.bookingCode);
  const UserId = sessionStorage.getItem("UserId");

  // const [bookingCode]=selectedData?.bookingCodeId?.bookingCodeData.map((e)=>e.bookingCode)
  // const GetBookingCodeDetails=()=>{
  //   GetBookingCode({isAscending:true}).then((res)=>{
  //     const bookData=res?.data;
  //     console.log("book:",bookData)
  //     // setBookingCodeValue(bookData.bookingCode);
  //   })
  // }


  useEffect(() => {
    if (formType === "edit") {
      Object.keys(initialValues).forEach((el) => {
        initialValues[el] = selectedData[el];
      });
      // formRef.setFieldValue('companyName', selectedData?.companyId?.shortName)
      // formRef.setFieldValue(
      //   "bookingCode",
      //   selectedData?.bookingCodeId?.bookingCode
      // );
      // formRef.setFieldValue('product', selectedData?.productId?.product)
      // formRef.setFieldValue('policyType', selectedData?.policyTypeId?.policyType)
      // formRef.setFieldValue(
      //   "paCover",
      //   selectedData?.paCover
      // );
      // formRef.setFieldValue("")
    }
    formRef.setFieldValue(initialValues);
  }, []);

  const onSubmit = (e, data, keys) => {
    // console.log("Data:", data);
    // return true;
    if (data?.loginIdFull) {
      if (e.key === "Enter" || keys === "Save") {
        const UpdatedTime = new Date();
        // data.branchName = data?.branchName?.toUpperCase()
        // data.remarks = data?.remarks?.toUpperCase()
        data.updatedAt = UpdatedTime;
        if (formType === "add") {
          data.createdBy = UserId;
        } else if (formType === "edit") {
          data.updatedBy = UserId;
        }
        let SubmitType =
          formType === "edit"
            ? UpdatePolicyList(selectedData?._id, data)
            : null;
        SubmitType.then((res) => {
          GetActiveData();
          // ToastSuccess(res.message);
          setOpenDrawer(false);
        }).catch((error) => {
          console.log(error);
        });
      }
    } else {
      ToastError("Choose the loginId");
    }
  };
  return (
    <>
      <div>
        <Grid container className="DrawerHeader">
          <Grid item xs={6} sm={6}>
            <Typography>Update Login ID</Typography>
          </Grid>
          <Grid item xs={6} sm={6} className="d-flex justify-content-end">
            <CloseIcon
              onClick={() => setOpenDrawer(false)}
              sx={{ cursor: "pointer" }}
            />
          </Grid>
        </Grid>

        <div className="container-fluid">
          <Formik
            initialValues={initialValues}
            // onSubmit={(values) => {
            //   onSubmit(values);
            // }}
            innerRef={(ref) => {
              if (ref) {
                formRef = ref;
              }
            }}
          >
            {({ values, setFieldValue }) => (
              <Form>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Policy Number
                    </Typography>
                    <TextField
                      name="policyNumber"
                      className="w-100"
                      variant="standard"
                      placeholder="Enter TP"
                      value={selectedData?.policyNumber?.replace("'", "")}
                      disabled
                      InputProps={{
                        className: "InputFiled",
                        disableUnderline: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              sx={{ p: 0, mr: 1 }}
                              onClick={() => {
                                setIsEyeLoading(true);
                                handleOnClickBehaviour(
                                  selectedData,
                                  false,
                                  () => setIsEyeLoading(false)
                                );
                              }}
                              disabled={isEyeLoading}
                            >
                              {isEyeLoading ? (
                                <CircularProgress
                                  size={18}
                                  sx={{ color: "grey" }}
                                />
                              ) : (
                                <RemoveRedEyeIcon
                                  sx={{ fontSize: "18px", color: "grey" }}
                                />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      companyName
                    </Typography>
                    <Field
                      name="companyName"
                      className="InputFiled"
                      placeholder="Enter TP"
                      value={selectedData?.companyId?.shortName}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      User
                    </Typography>
                    <Field
                      name="user"
                      className="InputFiled"
                      value={selectedData?.userId?.name}
                      style={{ textTransform: "uppercase" }}
                      disabled
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      companyName
                    </Typography>
                    <Field
                      key={refreshField}
                      name="bookingCode"
                      className="InputFiled"
                      style={{ textTransform: "uppercase" }}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Sub BookingCode
                    </Typography>

                    <Field
                      key={refreshFieldSubCode}
                      name="subBookingCode"
                      className="InputFiled"
                      style={{ textTransform: "uppercase" }}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} mb={2}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Select LoginId
                    </Typography>

                    <Autocomplete
                      name="loginIdFull"
                      // disablePortal
                      disablePortal={false}
                      className="AutoComplete_InputBox"
                      id="combo-box-demo"
                      value={selectedLoginPortal}
                      options={loginPortalDetails}
                      loading={loginPortalLoading}
                      onChange={(e, v) => {
                        // console.log("v :::::", v);
                        setSelectedLoginPortal(v?.loginPortal);
                        setFieldValue("loginId.companyId", v?.companyId);
                        setFieldValue("loginId.userId", v?.userId);
                        setFieldValue("loginIdFull", v?.loginPortal);
                        setFieldValue("bookingCode", v?.bookingCode);
                        setFieldValue("subBookingCode", v?.subBookingCode);
                        setFieldValue("bookingCodeId", v?.bookingCodeId);
                        setFieldValue("subBookingCodeId", v?.subBookingCodeId);
                        setRefreshField(refreshField + 1);
                        setRefreshFieldSubCode(refreshFieldSubCode + 1);
                      }}
                      renderOption={(props, option) => (
                        <li {...props} key={option._id}>
                          {option.loginPortal}
                        </li>
                      )}
                      getOptionLabel={(option) => {
                        return typeof option === "object"
                          ? option.loginPortal
                          : option;
                      }}
                      isOptionEqualToValue={(e, v) => {
                        return e.loginPortal === v;
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </Grid>
                  {/* <Grid item xs={12} sm={6}>
                    <FloatLabel
                      label="Reg Number"
                      value={selectedData?.registrationNumber}
                    >
                      <Field
                        name="registrationNumber"
                        value={selectedData?.registrationNumber}
                        className="InputFiled"
                        disabled
                      />
                    </FloatLabel>
                  </Grid> */}
                  {/* <Grid item xs={12} sm={4}>
                    <FloatLabel
                      label="Product"
                      value={selectedData?.productId?.product}
                    >
                      <Field
                        name="product"
                        className="InputFiled"
                        value={selectedData?.productId?.product}
                        style={{ textTransform: "uppercase" }}
                        disabled
                      />
                    </FloatLabel>
                  </Grid> */}
                  {/* <Grid item xs={12} sm={4}>
                    <FloatLabel
                      label="Policy Type"
                      value={selectedData?.policyTypeId?.policyType}
                    >
                      <Field
                        name="policyType"
                        className="InputFiled"
                        value={selectedData?.policyTypeId?.policyType}
                        style={{ textTransform: "uppercase" }}
                        disabled
                      />
                    </FloatLabel>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FloatLabel label="PA Cover" value={selectedData?.paCover}>
                      <Field
                        name="paCover"
                        className="InputFiled"
                        value={selectedData?.paCover}
                        style={{ textTransform: "uppercase" }}
                        disabled
                      />
                    </FloatLabel>
                  </Grid> */}
                  <div className="Dialog_Footer">
                    <Button
                      className="Dialog_Cancel"
                      onClick={() => setOpenDrawer(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      className="Dialog_Save_Exit"
                      onClick={(e) => onSubmit(e, values, "Save")}
                    >
                      {selectedData?._id ? "Update" : "Save"}
                    </Button>
                  </div>
                  {/* <Grid className="DrawerFooter" item xs={12} sm={12} gap={1}>
                    <button onClick={() => setOpenDrawer(false)}>Cancel</button>
                    <button
                      // type="submit"
                      onClick={(e) => onSubmit(e, values, "Save")}
                    >
                      {selectedData?._id ? "Update" : "Save"}
                    </button>
                  </Grid> */}
                </Grid>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
};

export default UpdateLoginStatus;
